module.exports = __webpack_public_path__ + "static/image/sustainability/m/ethical@2x.ver2_0_2.jpg?973d28cb";